const blue300Color = '#7ca5ce';

export default blue300Color;
